import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { STORAGE_TOKEN_KEY } from 'configs/constant'
import { responseUser, userModel } from 'models/user'
import { fetchUser } from 'services/userService'
import { notifyError } from 'utilities/Notification'

// Define a type for the slice state
interface initialState {
  isLoading: boolean
  user: userModel | null
  success: boolean
}

// Define the initial state using that type
const initialState = {
  isLoading: false,
  user: {
    id: 0,
    name: '',
    role_id: 0
  },
  errorMessage: '',
  success: false
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logout: (state: any) => {
      state.isLoading = false
      state.user = null
      state.success = false
      localStorage.clear()
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchUser.pending, (state) => {
      state.isLoading = true
    })
    builder.addCase(fetchUser.fulfilled, (state, action: PayloadAction<responseUser>) => {
      state.isLoading = false
      if (action.payload?.access_token) {
        state.user = action.payload.user
        localStorage.setItem(STORAGE_TOKEN_KEY, action.payload.access_token)
        state.success = true
      } else {
        notifyError({ message: 'ユーザIDまたはパスワードが違います。' })
      }
    })
    builder.addCase(fetchUser.rejected, (state) => {
      state.isLoading = false
      state.errorMessage = 'error'
      notifyError({ message: 'error' })
    })
  }
})
export const { logout } = userSlice.actions
export default userSlice.reducer
